import { Hero } from "@/components/home/Hero";
import { Positioning } from "@/components/home/Positioning";
import { Portfolio } from "@/components/home/Portfolio";
import { WorkTogether } from "@/components/home/WorkTogether";
import { Founder } from "@/components/home/Founder";
import { Testimonials } from "@/components/home/Testimonials";
import { usePageMeta } from "@/lib/pageMeta";

export const Home = () => {
    // No title of its own: the site-wide one already names the studio, and
    // "Home — RockFox Studio" would say less.
    usePageMeta({ title: null, path: "/" });

    return (
        <>
            <Hero />
            <Positioning />
            <Portfolio />
            <WorkTogether />
            <Founder />
            <Testimonials />
        </>
    );
};
